module.exports = __webpack_public_path__ + "img/antes_despues_290.b3134387.png";